import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCards, Autoplay } from "swiper/modules";
import ImageKit from "./ImageKit";

import "swiper/css";
import "swiper/css/effect-cards";

const UpcomingEvents = () => {
  const events = [
    {
      title: "Sip for a cause, bloom with purpose",
      description: "JCI Fundraising",
      time: "May 25 - 30, 2026 @ 4:00 PM - 10:00 PM",
      where: "In front of lucena watsons downtown",
      agenda: "some agenda",
      image: "/upcoming-events/pasayahan-pub-mat"
    },
    {
      title: "41st YLEA: Youth Leadership Excellence Awards 2026",
      description: "Celebrating the outstanding achievements of young leaders.",
      time: "1:00 PM",
      where: "Asuncion Hall, Flores Bldg. Brgy. Market View, Lucena City",
      agenda: "some agenda",
      image: "/upcoming-events/ylea.jpg"
    },
    {
      title: "Area 3 Sports Fest 2026",
      description: "JCI Area Sports Fest",
      time: "7:00 AM - 5:00 PM",
      where: "Inigos Sports Center, Lucena City",
      agenda: "some agenda",
      image: "/upcoming-events/area-sports-fest"
    },
  ];

  return (
    <Swiper
      effect={"cards"}
      grabCursor={true}
      modules={[EffectCards, Autoplay]}
      autoplay={{
        delay: 3000,
        disableOnInteraction: false
      }}
      className="w-[320px] h-[220px]"
    >
      {events.map((item, index) => (
        <SwiperSlide
          key={index}
          className={`swiper-event-cards ${index % 2 === 0 ? "blue-bg-white-text": "white-bg-blue-text"}`}
        >
          <ImageKit 
            path={item.image}
            // ratio={imgPath.aspect}
            // alt={`${project.title} - ${index}`}
            className="events-image-main-frame"
          />
          <h2 className="upcoming-events-title">
            {item.title}
          </h2>
          <p className="upcoming-events-texts">
            <h4 style={{ display: 'inline' }}>Description:</h4> {item.description}
          </p> 
            {/* fix hydration error, h4 cannot be a descendent of p */}
          <p className="upcoming-events-texts">
            <h4 style={{ display: 'inline' }}>When:</h4> {item.time}
          </p>
          <p className="upcoming-events-texts">
            <h4 style={{ display: 'inline' }}>Where:</h4> {item.where}
          </p>
          {/* <p className="upcoming-events-texts">
            <h4 style={{ display: 'inline' }}>Agenda:</h4> {item.agenda}
          </p> */}
          {/* <button className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-lg">
            View
          </button> */}
        </SwiperSlide>
      ))}
    </Swiper>
  );
}

export default UpcomingEvents;